import { Box } from "@mui/material";
import styled from "styled-components";

export const ProviderSchedulesStyled = styled(Box)`
  .provider-tabs {
    margin-bottom: 16px;
  }

  .schedule-card {
    background-color: #fff;
    padding: 24px;
    border-radius: 20px;
    margin-bottom: 16px;
  }

  .schedule-grid {
    display: grid;
    grid-template-columns: 140px auto 1fr 1fr;
    gap: 12px 16px;
    align-items: center;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 8px;

      .day-row {
        display: grid;
        grid-template-columns: 120px auto 1fr 1fr;
        gap: 8px;
        padding: 8px 0;
        border-bottom: 1px solid #eee;
      }
    }
  }

  .day-label {
    font-weight: 500;
    color: #333;
  }

  .day-row {
    display: contents;
  }

  .day-row.disabled {
    opacity: 0.55;
  }

  .form-actions {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    margin-top: 24px;
  }

  .help-text {
    color: #666;
    font-size: 13px;
    margin-bottom: 16px;
  }
`;
